export default __webpack_public_path__ + "static/media/mp4.e119e32e.png";